export default {
  title: '推送',
  name: {
    lastName: '历史名称',
    required: '不能为空',
    label: '素材名称',
    prefixLabel: '素材名称前缀',
    suffixLabel: '素材名称后缀',
    code: {
      projectId: '项目ID',
      projectName: '项目名称',
      versionName: '版本名称',
      outputName: '作品名称',
      platform: '手机系统',
      autoIncrement: '自动序号',
      creative_version: '创意版本',
    },
    validate: {
      repeat: '素材名称已存在。',
    },
  },
  package: {
    size: '实际包体 {size} {symbol} {limit}',
    packError: '包体计算异常，请点击重试。',
  },
  channel: {
    title: '平台',
    selectAll: '全选',
    selectReverse: '反选',
    selectCount: '选中({count})',
    selectClear: '清空',
    selectTips: '请选择推送的账号或产品',
    emptyTips: '无可用帐号或产品',
    removeMintegral: '删除主账号将会一并删除该主账号下的子账号，确认删除吗？',
    removeUnity: '删除账号将会一并删除该账号下的产品，确认删除吗？',
    account: '账号',
    accountMain: '主账号',
    accountChild: '子账号',
    product: '产品',
    creativeSet: '创意组',
    inexistence: {
      product: '未找到当前项目关联的产品',
    },
    applovinTooltip: 'Applovin的单个创意组只允许上传一条可玩素材',
  },
  mtg: {
    save: {
      label: 'Mintegral存档下载',
    },
  },
}
